import React, { type FunctionComponent, Fragment } from 'react'
import { FormattedMessage } from 'react-intl'
import DocumentTitle from 'legacy/components/DocumentTitle'
import AppHeader from 'legacy/components/AppHeader'
import { PickupAnalytics } from 'domains/reports/components/pickup-analytics/PickupAnalytics'

interface Props {}

export const ReportsPickupAnalyticsPage: FunctionComponent<Props> = () => (
  <Fragment>
    <DocumentTitle titleId="reportsDomain.pickupAnalytics.title" />

    <AppHeader title={<FormattedMessage id="reportsDomain.pickupAnalytics.pageTitle" />} />

    <PickupAnalytics />
  </Fragment>
)
